import fetch from 'isomorphic-fetch';

export const localStoreFN = () => {
  let localStorage;
  if (typeof window === "undefined") {
    require('fs');
    let LocalStorage = require('node-localstorage').LocalStorage;
    localStorage = new LocalStorage('./scratch');
  } else {
    localStorage = window.localStorage;
  }
  return localStorage
}
export const saveLocalState = async (item) => {
  localStoreFN().setItem(item.key, item.value);
  const response = await fetch(`/api/localstore`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      credentials: 'include'
    }),
    body: JSON.stringify(item),
  });
  const data = await response.json();
  return data;
}

export const deleteLocalState = async () => {
  localStoreFN().clear();
  const response = await fetch(`/api/localstore`, {
    method: 'DELETE',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      credentials: 'include'
    })
  });
  const data = await response.json();
  return data;
}


// WEBPACK FOOTER //
// ./source/client/store/localStorage.js